import {memo} from 'react'

import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'

import {BASE_CLASS, ICON_TYPES, ICONS} from './config.js'

const CarfaxIconListItem = ({text, type = ICON_TYPES.OK}) => {
  const {icon: Icon, color} = ICONS[type]

  return text ? (
    <li className={`${BASE_CLASS}-listIconItemWrapper`}>
      <Icon size={atomIconSizes.medium} color={color} />
      <p className={`${BASE_CLASS}-listItemValue`}>{text}</p>
    </li>
  ) : (
    <></>
  )
}

CarfaxIconListItem.displayName = 'CarfaxIconListItem'
CarfaxIconListItem.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string
}

export default memo(CarfaxIconListItem)
